<template>
  <div class="col-12">
    <div class="card" v-if="product">
      <div class="card-body">
        <div class="form form-horizontal">
          <hr class="col-12 p-0"/>
          <span class="d-block col-12 text-uppercase">Product Information</span>
          <hr class="col-12 p-0"/>
          <div class="row m-0 form-group">
            <label class="col-6 col-md-4 col-lg-3">Parent Product</label>
            <div class="p-0 select col-6 col-md-8 col-lg-9">
              <kendo-dropdownlist class="form-control"
                :option-label="'Select Parent Product'"
                :data-source="parentDS"
                :filter="'contains'"
                :data-text-field="'name'"
                :data-value-field="'code'"
                v-model="product.parent.uid"></kendo-dropdownlist>
            </div>
          </div>
          <div class="row m-0 form-group">
            <label class="col-6 col-md-4 col-lg-3">Code</label>
            <input type="text" placeholder="Product Code" class="form-control col-6 col-md-8 col-lg-9" 
              v-model="product.code" v-bind:class=" { 'error': verification.code }"/>
            <small v-if="verification.code" class="form-feedback error col-md-8 col-lg-9 col-6 offset-6 offset-md-4 offset-lg-3 p-0">This information is required</small>
          </div>
          <div class="row m-0 form-group">
            <label class="col-6 col-md-4 col-lg-3">Name</label>
            <input type="text" placeholder="Product Name" class="form-control col-6 col-md-8 col-lg-9 text-capitalize"
              v-model="product.name"  v-bind:class=" { 'error': verification.name }"/>
            <small v-if="verification.name" class="form-feedback error col-md-8 col-lg-9 col-6 offset-6 offset-md-4 offset-lg-3 p-0">This information is required</small>
          </div>
          <div class="row m-0 form-group">
            <label class="col-6 col-md-4 col-lg-3">Unit</label>
            <div class="col-6 col-md-8 col-lg-9 p-0 select">
              <select class="form-control" v-model="product.unit">
                <option value="pcs">Pieces</option>
                <option value="pax">Pax</option>
                <option value="box">Box</option>
                <option value="unit">Unit</option>
              </select>
            </div>
            <small v-if="verification.unit" class="form-feedback error col-md-8 col-lg-9 col-6 offset-6 offset-md-4 offset-lg-3 p-0">This information is required</small>
          </div>
          <div class="row m-0 form-group">
            <label class="col-6 col-md-4 col-lg-3">Product Meta</label>
            <div class="p-0 col-6 col-md-8 col-lg-9">
              <input-tag :tags.sync="product.meta" :placeholder="'Product Meta'" :addTagOnKeys="[188]" style="text-indent: 10px"></input-tag>
            </div>
          </div>
          <div class="row m-0 form-group">
            <label class="col-6 col-md-4 col-lg-3">Description</label>
            <textarea type="text" placeholder="Product Description" class="form-control col-6 col-md-8 col-lg-9" v-model="product.description"></textarea>
          </div>
          <hr class="col-12 p-0"/>
          <span class="d-block col-12 text-uppercase">Prices Settings</span>
          <hr class="col-12 p-0"/>
          <div v-if="product.prices" class="row m-0 form-group" v-for="price in priceType" :key="price.name">
            <label class="col-6 col-md-4 col-lg-3 text-capitalize">{{price.name.toLowerCase()}}</label>
            <div class="col-6 col-md-8 col-lg-9 p-0">
              <numeric-text-box :min="0" :format="'c'" culture="id-ID" :value="Number(product.prices[price.name])" @change="priceChange($event, price.name)"></numeric-text-box>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-0 text-right">
      <button class="btn btn-primary" @click="submit">
        <i class="fa fa-save"></i>&nbsp;Update Product
      </button>
    </div>
  </div>
</template>

<script>
import InputTag from 'vue-input-tag'
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper'
import axios from 'axios'

var token = JSON.parse(localStorage.getItem('token'))
var accessToken = ''
if (token) {
  accessToken = token.access_token
}

const axiosInstance = axios.create({
  baseURL: process.env.API_SERVER,
  headers: {
    'Authorization': 'Bearer ' + accessToken
  }
})

export default {
  data () {
    return {
      uid: '',
      parent: '',
      product: {
        name: '',
        code: '',
        unit: '',
        description: '',
        parent: {
          uid: '',
          name: ''
        }
      },
      parents: [],
      priceType: [],
      verification: {
        name: false,
        code: false,
        unit: false
      },
      parentDS: {
        schema: {
          count: 'count',
          data: 'results',
          parse: function (response) {
            for (var i = 0; i < response.results.length; i++) {
              response.results[i].code = response.results[i].uid
            }
            return response
          }
        },
        transport: {
          read: function (event) {
            axiosInstance.get('api/sales/products/parents/')
              .then(
                (response) => {
                  event.success(response.data)
                }
              )
          }
        }
      },
      tagDS: {
        schema: {
          data: 'results',
          count: 'count'
        },
        transport: {
          read: function (event) {
            axiosInstance.get('api/sales/products/tags/')
              .then(
                (response) => {
                  event.success(response.data)
                }
              )
          },
          noDataTemplate: function () {
            return '<div>No data found. Do you want to add new item - \'#: instance.element.val() #\' ?</div><br />' +
                    '<button class="k-button" onclick="addNew(\'#: instance.element[0].id #\', \'#: instance.element.val() #\')">Add new item</button>'
          }
        }
      }
    }
  },
  components: {
    InputTag,
    NumericTextBox
  },
  created () {
    // get code from params
    this.uid = this.$route.params.uid
    // get sales type
    this.getSalesType()
  },
  methods: {
    getProduct () {
      var vm = this
      vm.axios('api/sales/products/' + vm.uid + '/')
        .then(
          (response) => {
            var product = response.data
            var prices = product.prices
            if (!prices) {
              prices = {}
            }
            for (var i = 0; i < vm.priceType.length; i++) {
              var type = vm.priceType[i].name
              if (!prices[type]) {
                prices[type] = 0
              } else {
                prices[type] = Number(prices[type])
              }
            }
            product.prices = prices
            if (product.parent === null) {
              product.parent = {
                uid: '',
                name: ''
              }
            }
            if (!product.meta) {
              product.meta = []
            }
            product.name = product.name.toLowerCase()
            vm.product = product
            console.log(vm.product)
          }
        )
    },
    getSalesType () {
      var vm = this
      vm.axios('api/inventory/outbound/type/')
        .then(
          (response) => {
            console.log(response)
            vm.priceType = response.data
            // get product
            vm.getProduct()
          }
        )
    },
    priceChange (event, type) {
      this.product.prices[type] = event.sender.value()
    },
    submit () {
      // do something here
      if (this.verify()) {
        var vm = this
        var data = new URLSearchParams()
        data.append('parent', vm.product.parent.uid)
        data.append('code', vm.product.code)
        data.append('name', vm.product.name)
        data.append('unit', vm.product.unit)
        data.append('meta', vm.product.meta)
        data.append('description', vm.product.description)
        data.append('prices', JSON.stringify(vm.product.prices))
        vm.axios.put('api/sales/products/' + vm.product.uid + '/', data)
          .then(
            (response) => {
              vm.$parent.showNotification('Product ' + vm.product.name.toUpperCase() + ' updated', 'success')
              vm.$router.push('/product/list')
            }
          )
          .catch(
            (error) => {
              console.log(error.response)
              console.log(error)
            }
          )
      }
    },
    verify () {
      if (this.product.code.length > 0 && this.product.name.length > 0 && this.product.unit.length > 0) {
        this.verification.code = false
        this.verification.name = false
        this.verification.unit = false
        return true
      }
      if (this.product.code.length === 0) {
        this.verification.code = true
      } else {
        this.verification.code = false
      }
      if (this.product.name.length === 0) {
        this.verification.name = true
      } else {
        this.verification.name = false
      }
      if (this.product.unit.length === 0) {
        this.verification.unit = true
      } else {
        this.verification.unit = false
      }
      return false
    }
  }
}
</script>

<style scoped>
  .form-group {
    margin-bottom: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/EditProduct.vue